const TreatmentPlanViewFilters = {
  default: [

      {
  label: "Gender",
  key: "gender",
  options: [
    "Male",
    "Female",
  ]
},


  ],
  additional: [
  {
      label: "Date",
      key: "appointmentDate",
      operator: "Between",
      inputType: "date-range",
    }
  ]
};

export default TreatmentPlanViewFilters; 